{
  "version": 2,
  "name": "Isles of Scilly",
  "displayInfo": {
    "description": "A low-lying archipelago off the coast of Cornwall. Exposed Atlantic swell, shallow rocks, and no shelter when the weather turns.",
    "difficulty": "expert"
  },
  "region": {
    "dataSource": {
      "type": "emodnet-wcs",
      "coverageId": "emodnet__mean"
    },
    "bbox": {
      "minLat": 49.85,
      "minLon": -6.45,
      "maxLat": 49.99,
      "maxLon": -6.2
    },
    "interval": 30,
    "simplify": 200,
    "scale": 1,
    "minPerimeter": 1500,
    "minPoints": 4,
    "flipY": true
  },
  "waves": {
    "sources": [
      {
        "amplitude": 1.2,
        "wavelength": 520,
        "direction": 0.0,
        "phaseOffset": 0.0
      },
      {
        "amplitude": 0.7,
        "wavelength": 620,
        "direction": -0.39,
        "phaseOffset": 1.62
      },
      {
        "amplitude": 0.5,
        "wavelength": 400,
        "direction": 0.39,
        "phaseOffset": 3.24
      },
      {
        "amplitude": 0.3,
        "wavelength": 900,
        "direction": -0.18,
        "phaseOffset": 4.85
      },
      {
        "amplitude": 0.55,
        "wavelength": 75,
        "direction": -0.79,
        "phaseOffset": 0.19
      },
      {
        "amplitude": 0.35,
        "wavelength": 48,
        "direction": 0.05,
        "phaseOffset": 1.81
      },
      {
        "amplitude": 0.22,
        "wavelength": 22,
        "direction": -0.75,
        "phaseOffset": 3.43
      },
      {
        "amplitude": 0.1,
        "wavelength": 9,
        "direction": 0.0,
        "phaseOffset": 5.04
      }
    ]
  },
  "wind": {
    "sources": [
      {
        "direction": -0.79
      }
    ]
  },
  "startPosition": [0, 0],
  "trees": {
    "spacing": 35,
    "density": 0.75,
    "minElevation": 4,
    "maxElevation": 500
  }
}
